<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("AJOUTER_UNE") : $t("MODIFICATION_DE") }} {{$t("QUESTION")}}  </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
        <div class="p-6">
          <p class="pt-4">{{ $t("question") }}<b style="color: #ff6141" >*</b> </p>
          <vs-textarea
             v-validate="'required'"
            data-vv-validate-on="blur"
            name="nametype"
            v-model="input.description"
            rows="3"
            class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('nametype')">{{$t("question_error")}}</span>
          
          <p class="pt-4">{{ $t("categorie") }}<b style="color: #ff6141" >*</b> </p>
              <vs-select
                v-model="input.category"
                data-vv-validate-on="blur"
                v-validate="'required'"
                autocomplete
                name="category"
                class="w-full"
            >
          <vs-select-item :key="item" :value="item.id" :text="item.name" v-for="item in categories" /></vs-select>
          
          <span class="text-danger text-sm" v-show="errors.has('category')">{{$t("categorie_error")}}</span>


          <p class="pt-4">{{ $t("colorVrai") }}<b style="color: #ff6141"></b></p>
            <v-select
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    name="colorVrai"
                    :reduce="rep => rep.key"
                    class="w-full" 
                    label="name"
                    v-model="input.colorVrai"
                    :options="ColorsQuestions">
              </v-select>
          <span class="text-danger text-sm" v-show="errors.has('colorVrai')">{{$t("colorVrai_error")}}</span>
          
          <p class="pt-4">{{ $t("colorFaux") }}<b style="color: #ff6141"></b></p>
            <v-select
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    name="colorFaux"
                    :reduce="rep => rep.key"
                    class="w-full" 
                    label="name"
                    v-model="input.colorFaux"
                    :options="ColorsQuestions">
              </v-select>
          <span class="text-danger text-sm" v-show="errors.has('colorFaux')">{{$t("colorFaux_error")}}</span>
          

          <p class="pt-4">{{ $t("colorNa") }}<b style="color: #ff6141"></b></p>
            <v-select
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    name="colorNa"
                    :reduce="rep => rep.key"
                    class="w-full" 
                    label="name"
                    v-model="input.colorNa"
                    :options="ColorsQuestions">
              </v-select>
          <span class="text-danger text-sm" v-show="errors.has('colorNa')">{{$t("colorNa_error")}}</span>
          
        </div>
      </component>
  
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="category_validate">{{$t("Soumettre")}}</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t("Annuler")}}</vs-button>
      </div>
    </vs-sidebar>
  </template>
  
<script>
  
// For custom error message
import { Validator } from 'vee-validate'
  
const dict = {
  custom: {
  
    nametype: {
      required: 'Le champ tâche est obligatoire'
    }
  }
}
  
// register custom messages
Validator.localize('en', dict)
  
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  
const input_tempon = {
  description: '',
  colorVrai: '',
  colorFaux:'',
  colorNa:'',
  category:''
}
  
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      categories: [],
      ColorsQuestions:[
        {
          key: 'red',
          name: 'Rouge'
        },
        {
          key: 'yellow',
          name: 'Jaune'
        }, {
          key: 'green',
          name: 'Vert'
        },
        {
          key: 'white',
          name: 'Blanc'
        }
      ],
      input: JSON.parse(JSON.stringify(input_tempon)),
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        
        this.input = JSON.parse(JSON.stringify(this.data))
        this.input.category = this.data.category.id
       
        this.initValues()
      }
    }
  },
  
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.input = JSON.parse(JSON.stringify(input_tempon))
    },
    category_validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitData()
        }
      })
    },
  
    async submitData () {
      this.$vs.loading()
      const input = JSON.parse(JSON.stringify(this.input))
  
      let url = 'questions/'
      let methods = 'post'
      const message = {
        error: this.$t('save_error'),
        success: this.$t('question_save')
      }
      if (input.id) {
        url += `${input.id}/`
        methods = 'put'
        message.success = this.$t('question_update')
      }
  
      this.$http[methods](url, input)
        .then((response) => {
          window.questions.getAllquestions()
          window.getPrendTaCom.success(message.success, response)
          this.$emit('closeSidebar')
          this.initValues()
        })
        .catch((error) => {
  
          const clefs = Object.keys(error.response.data)
          for (let i = 0; i < clefs.length; i++) {
            const item = clefs[i]
            let libelle = ''
            if (item === 'name') {
              libelle = this.$t('question')
            }
            if (item === 'colorFaux') {
              libelle = this.$t('Couleur faux')
            }
            if (item === 'colorVrai') {
              libelle = this.$t('Couleur vrai')
            }
            for (let j = 0; j < error.response.data[item].length; j++) {
              window.getPrendTaCom.error(`${libelle} :  ${error.response.data[item][j]}`)
            }
          }
  
          window.getPrendTaCom.error(message.error)
        })
    },
    getAllcategories () {
      this.$vs.loading()
      this.$http.get('categories/')
        .then((response) => {
          this.categories = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  
  },

  created () {
    this.getAllcategories()

  }
}
</script>
  
  <style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }
  
    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
  
      .img-upload {
        margin-top: 2rem;
  
        .con-img-upload {
          padding: 0;
        }
  
        .con-²-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  
  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  
    &:not(.ps) {
      overflow-y: auto;
    }
  }
  </style>
  